import React, { useState, useRef } from 'react';
import { Input } from 'antd';
import Navigations from '../../components/navigation';
import Footer from '../../components/footer';
import Logo from '@public/images/logo.png';
import index1 from '@public/images/index1.jpg';
import icon27 from '@public/images/icon27.jpg';
import icon28 from '@public/images/icon28.png';
import icon30 from '@public/images/icon30.png';
import HotComp2 from '../../components/hotComp2';
import HotComp3 from '../../components/hotComp3';

import './index.less';

import SwiperCore, { Navigation, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';

SwiperCore.use([Navigation, Autoplay]);

function App() {
	const [name, setName] = useState('船舶海工产业');
	const handelName = (val) => {
		setName(val);
	};
	return (
		<div className="app">
			<Navigations
				active={3}
				list={[
					{ name: '首页', path: 'index.html' },
					{ name: '走进南通', path: 'info.html' },
					{ name: '人才优享', path: 'policy.html' },
					{ name: '人才招引', path: 'attract.html' },
					// { name: '"南通日"高校毕业生招聘', path: 'ocean.html' },
					{ name: '才涌江海潮正劲', path: 'jobs.html' },
						// { name: '绿茵场外新“赛道” “千企万岗”等你来', path: 'arrange.html' },
{ name: '海洋产业校园行（黑龙江高校）专场招聘', path: 'jobs-heilongjiang.html' },,
				]}
				logo={Logo}
			/>
			<div className="index-container">
				<div className="swiper-video-container">
					<img className="attract1" src={icon28} alt="" />
					<div className="hot-jobs">
						<HotComp3 />
					</div>
					<img className="attract2" src={icon30} alt="" />
					<div className="hot-company">
						<div className="title">
							<span className="name">{name}</span>
							<span className="tip">入选全国先进制造业集群</span>
						</div>

						<HotComp2 handelName={handelName} />
					</div>
				</div>
				<Swiper
					style={{ marginBottom: '-5px' }}
					autoplay={true}
					initialSlide={0}
					speed={3000}
					loop={true}
				>
					<SwiperSlide>
						<img className="img1" src={index1} alt="" />
					</SwiperSlide>
				</Swiper>
				<img className="img2" src={icon27} alt="" />
			</div>
			<Footer />
		</div>
	);
}

export default App;
